import { ActionTypesFactory } from "../../common/redux/actions/ActionTypesFactory";

const counterStatesActionTypes = ActionTypesFactory.readActionTypes(
  "COUNTERSTATE"
);

export default counterStatesActionTypes;
